import Auth from "./Auth";

class Admin {
	static async get(id) {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			try {
				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${id}`,
					{
						method: "GET",
						headers: {
							"Authorization": `Bearer ${session.token}`,
							"Content-Type": "application/json"
						}
					}
				);

				if (response.ok) {
					result.data = await response.json();

					if (result.data instanceof Object === false) {
						result.data = {};
					} else if (result.data.image && typeof result.data.image === "string") {
						result.data.image = `${process.env.REACT_APP_BASE_URL}/${result.data.image}`;
					}
				}

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}

	static async getAll() {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			try {
				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin`,
					{
						method: "GET",
						headers: {
							"Authorization": `Bearer ${session.token}`,
							"Content-Type": "application/json"
						}
					}
				);

				if (response.ok) {
					result.data = await response.json();

					if (!Array.isArray(result.data)) {
						result.data = [];
					}
				}

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}

	static async edit(id, username, email, password, image) {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			const formData = new FormData();
			formData.append("username", username);
			formData.append("email", email);

			if (password) {
				formData.append("password", password);
			}

			let contentType = "application/json";

			if (image === "") {
				formData.append("removeImage", true);
			} else if (image instanceof Object) {
				formData.append("image", image);
				contentType = "multipart/form-data";
			}

			try {
				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${id}`,
					{
						method: "PUT",
						headers: {
							"Authorization": `Bearer ${session.token}`
						},
						body: formData
					}
				);

				if (response.ok) {
					result.data = await response.json();

					if (result.data.image) {
						result.data.image = `${process.env.REACT_APP_BASE_URL}/${result.data.image}`;
					}
				}

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}

	static async changeState(id, state) {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			try {
				const data = {state};
				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${id}`,
					{
						method: "PATCH",
						headers: {
							"Authorization": `Bearer ${session.token}`,
							"Content-Type": "application/json"
						},
						body: JSON.stringify(data)
					}
				);

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}

	static async delete(id) {
		const result = {};
		const session = Auth.getSession();

		if (session) {
			try {
				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/admin/${id}`,
					{
						method: "DELETE",
						headers: {
							"Authorization": `Bearer ${session.token}`,
							"Content-Type": "application/json"
						}
					}
				);

				result.status = response.status;
			} catch (error) {
				result.status = (error.response) ? error.response.status : 500;
			}
		} else {
			result.status = 401;
		}

		return result;
	}
}

export default Admin;
